import { Button } from "@mui/material";
import React from "react";

const CommonButton = ({
    label,
    handleClick,
    size,
    type,
    disabled,
    startIcon,
    endIcon,
    width,
    height,
    color,
    background,
    marginBottom,
    fontWeight,
    border,
    borderRadius,
    marginTop,
    fontSize
}) => {
    return (
        <Button
            fullWidth
            type={type}
            variant="contained"
            size={size}
            disabled={disabled}
            onClick={(e) => {
                if (handleClick) handleClick(e)
            }}
            startIcon={startIcon}
            endIcon={endIcon}
            sx={{
                height: height || '40px',
                mb: marginBottom || 3,
                mt: marginTop,
                backgroundColor: background || 'primary.main',
                color: color || 'secondary.main',
                '&:hover': {
                    backgroundColor: background || 'primary.main',
                    color: color || 'secondary.main',
                    boxShadow: 'none'
                },
                width: width || '100%',
                fontWeight: fontWeight || 'normal',
                border: border || 'none',
                boxShadow: 'none',
                borderRadius: borderRadius,
                fontSize: fontSize
            }}
        >
            {label}
        </Button>
    )
}

export default CommonButton;